/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "./src/css/global.css"
import * as React from "react";
import { ApolloProvider } from "@apollo/client/react";
import createEmotionCache from './src/createEmotionCache';
import { CacheProvider } from '@emotion/react';
import client from "./src/apollo/client";

const clientSideEmotionCache = createEmotionCache();
export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    {element && (<CacheProvider value={clientSideEmotionCache}>
      {element}
    </CacheProvider>)}
  </ApolloProvider>
);
